define('OutSystems/ClientRuntime/RegExpHelper',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.escape = exports.replace = exports.matches = exports.Match = void 0;
    var Match = (function () {
        function Match(match, regExpIndex) {
            this._groups = match;
            this._index = regExpIndex - this._groups[0].length;
        }
        Object.defineProperty(Match.prototype, "value", {
            get: function () {
                return this._groups[0];
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Match.prototype, "index", {
            get: function () {
                return this._index;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Match.prototype, "length", {
            get: function () {
                return this._groups[0].length;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Match.prototype, "groups", {
            get: function () {
                return this._groups;
            },
            enumerable: false,
            configurable: true
        });
        return Match;
    }());
    exports.Match = Match;
    function matches(text, regExpText, caseInsensitive) {
        if (caseInsensitive === void 0) { caseInsensitive = false; }
        var result = [];
        var regExp = new RegExp(regExpText, "g" + (caseInsensitive ? "i" : ""));
        var matchAux = regExp.exec(text);
        while (matchAux) {
            result.push(new Match(matchAux, regExp.lastIndex));
            matchAux = regExp.exec(text);
        }
        return result;
    }
    exports.matches = matches;
    function replace(text, regExpText, caseInsensitive, matchEvaluator) {
        if (caseInsensitive === void 0) { caseInsensitive = false; }
        var matchesArr = matches(text, regExpText, caseInsensitive);
        var result = text;
        var adjustment = 0;
        for (var i = 0; i < matchesArr.length; i++) {
            var match = matchesArr[i];
            var replacement = matchEvaluator(match);
            result =
                result.substr(0, match.index + adjustment) +
                    replacement +
                    result.substr(adjustment + match.index + match.length);
            adjustment += replacement.length - match.length;
        }
        return result;
    }
    exports.replace = replace;
    function escape(s) {
        return !s ? s : s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    exports.escape = escape;
});
//# sourceMappingURL=RegExpHelper.js.map;
